import React from 'react';

const Footer = () => {
    return (
        <div className=" mt-5 bg-dark text-white">
            {/* footer text */}
            <small>All right reserved © Mandal-EyeCare</small>
        </div>
    );
};

export default Footer;